// 侧栏导航数据（PRD §4.4 页面清单）：路由 path 与 App.tsx 路由表一一对应。
// 纯数据文件（同 market 的 features/shell/nav.ts）：图标只存 key，画法在 AppLayout.tsx 的 navIcons 表。

import { CAPABILITIES, type Capability } from "../../../shared/capabilities";

/** 导航图标 key，对应 AppLayout.tsx 的 navIcons 表 */
export type NavIconKey =
  | "home"
  | "doc"
  | "check"
  | "users"
  | "flag"
  | "bulb"
  | "trophy"
  | "medal"
  | "star"
  | "chat"
  | "warn"
  | "swap"
  | "book"
  | "horn"
  | "rank"
  | "coins"
  | "gear"
  | "pulse"
  | "help"
  | "user"
  | "key";

export interface NavItem {
  to: string;
  label: string;
  /** 任一能力命中即可见 */
  anyOf: Capability[];
  icon: NavIconKey;
  /** 仅精确匹配高亮（如 "/"） */
  end?: boolean;
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    title: "概览",
    items: [
      { to: "/", label: "工作台", anyOf: ["employee"], icon: "home", end: true },
      { to: "/ranking", label: "排行榜", anyOf: ["employee"], icon: "rank" },
      { to: "/publicity", label: "公示", anyOf: ["employee"], icon: "horn" },
    ],
  },
  {
    title: "申报",
    items: [
      { to: "/claims", label: "申报中心", anyOf: ["employee"], icon: "doc" },
      { to: "/innovation", label: "创新成果", anyOf: ["employee"], icon: "bulb" },
      { to: "/adhoc", label: "一事一议", anyOf: ["employee"], icon: "chat" },
    ],
  },
  {
    title: "渠道管理",
    items: [
      { to: "/dept-contribution", label: "部门贡献", anyOf: ["dept_head", "ops", "admin"], icon: "users" },
      { to: "/projects", label: "项目积分", anyOf: ["employee"], icon: "flag" },
      { to: "/contests", label: "竞赛", anyOf: ["employee"], icon: "trophy" },
      { to: "/honors", label: "荣誉表彰", anyOf: ["employee"], icon: "medal" },
      { to: "/committee", label: "委员积分", anyOf: ["employee"], icon: "star" },
    ],
  },
  {
    title: "审批与运营",
    items: [
      { to: "/approvals", label: "审批中心", anyOf: ["dept_head", "ops", "decide", "review", "verify", "admin"], icon: "check" },
      { to: "/deductions", label: "违纪扣分", anyOf: ["dept_head", "ops", "decide", "verify", "admin"], icon: "warn" },
      { to: "/ledger", label: "台账", anyOf: ["ops", "decide", "review", "verify", "admin"], icon: "book" },
      { to: "/budget", label: "预算", anyOf: ["ops", "decide", "verify", "admin"], icon: "coins" },
    ],
  },
  {
    title: "我的",
    items: [
      { to: "/redemptions", label: "兑换中心", anyOf: ["employee"], icon: "swap" },
      { to: "/account", label: "个人中心", anyOf: ["employee"], icon: "user" },
    ],
  },
  {
    title: "工具",
    items: [{ to: "/tools/api-keys", label: "API 密钥", anyOf: [...CAPABILITIES], icon: "key" }],
  },
  {
    title: "系统",
    items: [
      { to: "/admin", label: "系统管理", anyOf: ["admin"], icon: "gear" },
      { to: "/admin/agent-logs", label: "Agent 调用日志", anyOf: ["admin"], icon: "pulse" },
    ],
  },
  {
    title: "帮助",
    items: [{ to: "/help", label: "用户手册", anyOf: ["employee"], icon: "help" }],
  },
];
